import React, { useState, useEffect } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";

export default function TicketUpdateDialog({
  handleClose,
  handleSubmitStatus,
}) {
  const { localization } = useLanguageContext();
  const [ticketStatus, setTicketStatus] = useState("Close");
  const [closeReason, setCloseReason] = useState("");

  useEffect(() => {
    if (ticketStatus != "Close") {
      setCloseReason("");
    }
    return () => {};
  }, [ticketStatus]);

  return (
    <div
      className="modal in dialogBox "
      id="MsgModalCenter"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="MsgModalCenterTitle"
      aria-hidden="true"
    >
      <div
        className="modal-dialog d-flex justify-content-center"
        role="document"
      >
        <div className="modal-content modelStyle">
          <div className="modal-header">
            <h5 className="modal-title">{localization.headerStatus}</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form
            id="ticketStatus"
            name="ticketStatus"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmitStatus({
                status: ticketStatus,
                reason: closeReason,
              });
            }}
          >
            <div className="modal-body ">
              <div className="container">
                <div className="row">
                  <div className="col pl-0 pr-0">
                    <div className="form-group">
                      <select
                        className="form-control"
                        id="ticketStatus"
                        name="ticketStatus"
                        required
                        value={ticketStatus}
                        onChange={(e) => {
                          setTicketStatus(e.target.value);
                        }}
                      >
                        <option value={"Close"}>{localization.close}</option>
                        <option value={"Open"}>
                          {localization.openTicket}
                        </option>
                        <option value={"InProgress"}>
                          {localization.inprogress}
                        </option>
                      </select>
                    </div>
                    {ticketStatus == "Close" && (
                      <>
                        <div className="form-outline mb-4">
                          <input
                            type="text"
                            id="closeReason"
                            name="closeReason"
                            className="form-control"
                            placeholder={localization.enterReason}
                            required
                            value={closeReason}
                            onChange={(e) => {
                              setCloseReason(e.target.value);
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp">
                <button
                  type="submit"
                  className="btn btn-primary mb-4"
                  disabled={ticketStatus == "Close" && closeReason.trim() == ""}
                >
                  {localization.update}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
